module.exports = __webpack_public_path__ + "static/media/igen.73cca420.svg";